<script setup lang="ts">
  import SearchResultGroup from './search-result-group.vue'

  defineProps<{
    products: SearchProduct[],
  }>()
</script>

<template>
  <search-result-group
    v-slot="{ item: product }"
    :items="products"
    route-list="product list"
    route-detail="product detail"
    name="Produk">
    <div class="text-sm font-medium">
      {{ product.name }}
    </div>
    <div class="mb-1 text-xs text-gray-500">
      {{ product.category.full_name }}
    </div>
    <div class="flex items-center text-xs gap-1.5">
      <div class="text-gray-500 mt-1">
        <fa-icon icon="i-far-eye" />
      </div>
      <div>{{ product.views }} <span class="text-gray-500">dilihat</span></div>
    </div>
    <div class="flex items-center text-xs gap-1.5">
      <div class="text-gray-500 mt-1">
        <fa-icon icon="i-far-cart-shopping" />
      </div>
      <div>{{ product.sold }} <span class="text-gray-500">terjual</span></div>
    </div>
  </search-result-group>
</template>
